/* ISD homepage stage: DATA LAYER (which products does a category pill show, in which order, and how are they loaded).

   The pills are server-rendered blocks (blocks/_isd-stage-tab.liquid); each carries its configuration in data-cfg. No product
   data is embedded in the homepage except the prepared gift boxes (script[data-isdst-boxes], 3 items) and the few products a
   pill names by handle (script[data-isdst-inc], script[data-isdst-cur]). Everything else is fetched ON DEMAND when a pill is
   opened, from the alternate collection view templates/collection.isd-stage.liquid:

       GET <root>collections/<handle>?view=isd-stage&sort_by=<sort>&page=<n>      (JSON, 24 products per page, same origin)

   Sources of a pill (cfg.src)
     best_selling  collections/all sorted by Shopify's own best-selling rank (real paid orders). Only the products that
                   demonstrably have sales are shown: the unsold tail of that list is in strict newest-first order, so the last
                   place where the order is NOT newest-first marks the end of the sold products (salesPrefix, a safe lower
                   bound). With fewer than cfg.ms such products (or when forced) the hand-made list of the pill is used and the
                   pill is relabelled; with no list the pill hides. No counts, ranks or badges are ever invented.
     newest        collections/all with sort_by=created-descending, which the view answers as "newest PUBLISHED first" (published_at,
                   48 products); re-sorted here by published_at, then created_at, then id, newest first. Never random.
     boxes         the prepared gift boxes of the page (no request).
     all           the boxes first (cfg.bf), then collections/all in best-selling order.
     collection    one or several collections (cfg.s = [{h, a, x}], a = allow-list of types / "tag:Name" / "handle:x"), each paged
                   in turn, then the products named by handle (inc). Sorting is Shopify's (best-selling by default).

   Visibility rule (applied to everything that arrives, also to the server-rendered payloads): HIDDEN = tag cfg.hide (Produktų
   kolekcija) or search-hidden, box add-ons, or product type "Dėžutės" whose handle is not one of cfg.boxes. Gift cards and
   products without a photo are already dropped by the view (snippets/isd-stage-gate.liquid holds the same rule).
   Products are de-duplicated by id inside a pill. Drafts do not exist on the storefront.

   Loading: single-flight per feed, one in-memory cache (no localStorage), pages appended on demand (more()), background work
   (prime) waits 300 ms after the previous request and never runs in parallel with a shopper's request; HTTP 429 starts a 10 s
   cool-down. Errors are returned to the engine, which shows a calm retry state. */
(function () {
  'use strict';
  if (window.ISDStageFeed) return;

  function lc(s) { return String(s == null ? '' : s).toLowerCase(); }
  function json(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }

  // How many of the (visible, best-selling ordered) products are guaranteed to have sales: the sold products come first, the
  // unsold ones follow in newest-first order (created_at desc, id desc). Walking from the end, the first pair that is NOT in
  // that order proves the earlier product has sales. 0 = the whole list is newest-first = no usable sales signal.
  function salesPrefix(items) {
    function older(a, b) { return a.ca < b.ca || (a.ca === b.ca && a.i < b.i); }
    for (var i = items.length - 2; i >= 0; i--) if (older(items[i], items[i + 1])) return i + 1;
    return 0;
  }
  function newCmp(a, b) { return (b.pa - a.pa) || (b.ca - a.ca) || (b.i - a.i); }

  function create(o) {
    var C = o.cfg || {}, nav = o.nav, root = C.root || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var hideTag = lc(C.hide || 'Produktų kolekcija'), boxType = lc(C.boxType || 'Dėžutės');
    var addonType = lc(C.addonType || 'Dėžutės priedas'), addonTag = lc(C.addonTag || 'box-addon');
    var boxMap = {};
    (C.boxes || []).forEach(function (h) { boxMap[h] = 1; });

    function visible(p) {
      if (!p || !p.i || !p.h || !p.im) return false;
      var tg = '|' + (p.tg || '') + '|', ty = lc(p.ty);
      if (tg.indexOf('|' + hideTag + '|') > -1 || tg.indexOf('|search-hidden|') > -1) return false;
      if (ty === addonType || tg.indexOf('|' + addonTag + '|') > -1 || /-prie-dezutes$/.test(p.h)) return false;
      if (ty === boxType && !boxMap[p.h]) return false;
      return true;
    }
    function allowOK(p, a) {
      if (!a || !a.length) return true;
      var ty = lc(p.ty), tg = '|' + (p.tg || '') + '|';
      for (var k = 0; k < a.length; k++) {
        var e = a[k];
        if (e.indexOf('tag:') === 0) { if (tg.indexOf('|' + e.slice(4).trim() + '|') > -1) return true; }
        else if (e.indexOf('handle:') === 0) { if (p.h === e.slice(7).trim()) return true; }
        else if (e && ty === e) return true;
      }
      return false;
    }
    function list(arr) {
      var seen = {}, out = [];
      (arr || []).forEach(function (p) { if (visible(p) && !seen[p.i]) { seen[p.i] = 1; out.push(p); } });
      return out;
    }

    // ------------------------------------------------------------------ transport
    var inflight = 0, lastEnd = 0, cool = 0;
    function http(u, bg) {
      return new Promise(function (resolve, reject) {
        var start = function () {
          if (Date.now() < cool) { var e0 = new Error('cool-down'); e0.status = 429; reject(e0); return; }
          var ctl = typeof AbortController === 'function' ? new AbortController() : null;
          var to = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
          inflight++;
          // no custom headers: an Accept: application/json makes Shopify answer with its own JSON instead of the view
          fetch(u, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined }).then(function (r) {
            if (r.status === 404) return { miss: true };
            if (!r.ok) { var e = new Error('HTTP ' + r.status); e.status = r.status; throw e; }
            return r.text().then(function (t) {
              var j = JSON.parse(t);
              if (!j || j.v !== 1) throw new Error('bad payload');
              return j;
            });
          }).then(function (j) { clearTimeout(to); inflight--; lastEnd = Date.now(); resolve(j); },
            function (e) { clearTimeout(to); inflight--; lastEnd = Date.now(); if (e && e.status === 429) cool = Date.now() + 10000; reject(e); });
        };
        if (!bg) { start(); return; }
        // background work: only when nothing else is running, 300 ms after the previous request, never while the page is hidden
        (function wait() {
          if (inflight === 0 && !document.hidden && Date.now() - lastEnd >= 300) start(); else setTimeout(wait, 120);
        })();
      });
    }

    // ------------------------------------------------------------------ feeds (one per collection + sort, shared by every pill)
    var feeds = {};
    function feedFor(h, sort) {
      var k = h + '|' + (sort || '');
      return feeds[k] || (feeds[k] = { key: k, h: h, sort: sort || '', items: [], seen: {}, page: 0, more: true, p: null, err: null, miss: false });
    }
    function feedUrl(F, page) {
      var u = root + 'collections/' + encodeURIComponent(F.h) + '?view=isd-stage';
      if (F.sort && F.sort !== 'manual') u += '&sort_by=' + encodeURIComponent(F.sort);
      return u + '&page=' + page;
    }
    function feedPage(F, bg) {
      if (!F.more) return Promise.resolve(F);
      if (F.p) return F.p;
      var pg = F.page + 1;
      F.p = http(feedUrl(F, pg), bg).then(function (j) {
        F.err = null;
        if (j.miss) { F.more = false; F.miss = true; return F; }
        F.page = pg;
        F.more = !!j.more && pg < 40;
        (j.items || []).forEach(function (p) {
          if (!p || F.seen[p.i]) return;
          F.seen[p.i] = 1;
          if (visible(p)) F.items.push(p);
        });
        return F;
      }).then(function (f) { F.p = null; return f; }, function (e) { F.p = null; F.err = e; throw e; });
      return F.p;
    }

    // ------------------------------------------------------------------ tabs
    var boxItems = list(o.boxes);
    function stat(items) { return { F: { items: items, more: false, p: null }, a: null, cur: 0 }; }

    var tabs = [].slice.call(o.pills || []).map(function (el, i) {
      var cfg = {}, bid = el.getAttribute('data-bid') || '';
      try { cfg = JSON.parse(el.getAttribute('data-cfg') || '{}') || {}; } catch (e) { cfg = {}; }
      var T = {
        i: i, el: el, bid: bid, key: el.getAttribute('data-key') || '', src: cfg.src || 'collection',
        label: (el.textContent || '').trim(), alt: cfg.cl || '', sort: cfg.sort || 'best-selling', limit: Math.max(1, cfg.lim || 60),
        dot: !!cfg.dot, he: cfg.he !== false, bf: cfg.bf !== false, ms: cfg.ms || 5, forceCur: !!cfg.ca, subs: cfg.s || [],
        inc: nav ? list(json(nav.querySelector('script[data-isdst-inc="' + bid + '"]'))) : [],
        cur: nav ? list(json(nav.querySelector('script[data-isdst-cur="' + bid + '"]'))) : [],
        srcs: [], out: [], seen: {}, si: 0, done: false, p: null, err: null, loaded: false, mode: '', hidden: !!el.hidden
      };
      T.special = T.src === 'best_selling' || T.src === 'newest';
      if (T.src === 'boxes') T.srcs.push(stat(boxItems));
      else if (T.src === 'all') {
        if (T.bf) T.srcs.push(stat(boxItems));
        T.srcs.push({ F: feedFor('all', T.sort || 'best-selling'), a: null, cur: 0 });
      } else if (T.src === 'collection') {
        T.subs.forEach(function (s) { if (s && s.h) T.srcs.push({ F: feedFor(s.h, T.sort), a: s.a && s.a.length ? s.a.map(lc) : null, cur: 0 }); });
        if (T.inc.length) T.srcs.push(stat(T.inc));
      }
      return T;
    });

    // move everything the source has loaded so far into the tab; true when the tab is full
    function consume(T, S) {
      var F = S.F;
      while (S.cur < F.items.length) {
        var p = F.items[S.cur++];
        if (T.seen[p.i]) continue;
        if (S.a && !allowOK(p, S.a)) continue;
        T.seen[p.i] = 1; T.out.push(p);
        if (T.out.length >= T.limit) return true;
      }
      return false;
    }
    // keep pulling (sources in order, page after page) until the tab holds `want` products or everything is read
    function advance(T, want, bg) {
      return new Promise(function (resolve, reject) {
        (function loop() {
          if (T.done) return resolve();
          var S = T.srcs[T.si];
          if (!S) { T.done = true; return resolve(); }
          if (consume(T, S)) { T.done = true; return resolve(); }
          if (S.F.more) {
            if (T.out.length >= want) return resolve();
            feedPage(S.F, bg).then(loop, reject);
          } else { T.si++; loop(); }
        })();
      });
    }

    function loadBest(T, bg) {
      var F = feedFor('all', 'best-selling');
      return feedPage(F, bg).then(function () {
        var pre = salesPrefix(F.items);
        T.signal = pre;
        if (!T.forceCur && pre >= T.ms) { T.out = F.items.slice(0, Math.min(pre, T.limit)); T.mode = 'sales'; }
        else if (T.cur.length) { T.out = T.cur.slice(0, T.limit); T.mode = 'curated'; }
        else { T.out = []; T.mode = 'nosignal'; }
        T.done = true;
      });
    }
    function loadNew(T, bg) {
      var F = feedFor('all', 'created-descending');
      return feedPage(F, bg).then(function () {
        T.out = F.items.slice().sort(newCmp).slice(0, T.limit);
        T.mode = 'newest';
        T.done = true;
      });
    }

    function load(T, bg) {
      if (T.loaded) return Promise.resolve(T);
      if (T.p) return T.p;
      var pr = T.src === 'best_selling' ? loadBest(T, bg) : T.src === 'newest' ? loadNew(T, bg) : advance(T, 12, bg);
      T.p = pr.then(function () { T.p = null; T.err = null; T.loaded = true; return T; }, function (e) { T.p = null; T.err = e; throw e; });
      return T.p;
    }
    // the next chunk (a further page of the source in turn)
    function more(T, bg) {
      if (T.done) return Promise.resolve(T);
      if (T.p) return T.p;
      T.p = advance(T, T.out.length + 1, bg).then(function () { T.p = null; return T; }, function (e) { T.p = null; T.err = e; throw e; });
      return T.p;
    }
    function prime(T) { return load(T, true).catch(function () { return T; }); }

    return { tabs: tabs, load: load, more: more, prime: prime, visible: visible, boxItems: boxItems, feeds: feeds, salesPrefix: salesPrefix, newCmp: newCmp, url: feedUrl, feedFor: feedFor };
  }

  window.ISDStageFeed = { create: create, salesPrefix: salesPrefix, newCmp: newCmp };
})();
